export function Badge({ tone = "neutral", children }) {
  return <span className={`ops-badge ops-badge--${tone}`}>{children}</span>;
}
